<div class="items">
  <div class="item" *ngFor="let l of list">
    <div class="name">{{l.name}}</div>
    <div class="value">{{l.value | number:'1.0-0':'pt-BR'}}</div>
  </div>
</div>
